import React from 'react';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import WhoThisIsFor from './components/WhoThisIsFor';
import WhyItWorks from './components/WhyItWorks';
import WhatMakesUsDifferent from './components/WhatMakesUsDifferent';
import CoreFeatures from './components/CoreFeatures';
import HowItWorks from './components/HowItWorks';
import FounderTestimonials from './components/FounderTestimonials';
import TrustedEcosystems from './components/TrustedEcosystems';
import WhoWeAreNot from './components/WhoWeAreNot';
import InvestorConfidence from './components/InvestorConfidence';
import CompleteFAQ from './components/CompleteFAQ';
import ReadyToKnow from './components/ReadyToKnow';
import Footer from './components/Footer';
import EmailCapturePopup from '../../components/feature/EmailCapturePopup';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <TrustBar />
      <WhoThisIsFor />
      <WhyItWorks />
      <WhatMakesUsDifferent />
      <CoreFeatures />
      <HowItWorks />
      <FounderTestimonials />
      <TrustedEcosystems />
      <WhoWeAreNot />
      <InvestorConfidence />
      <CompleteFAQ />
      <ReadyToKnow />
      <Footer />
      <EmailCapturePopup />
    </div>
  );
};

export default HomePage;
